import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './footer/footer.component';
import { LoginComponent } from './login/login.component';
import { OptimizerComponent } from './optimizer/optimizer.component';
import { OptimizerServiceService } from './optimizer-service.service';
import { PrintComponent } from './print/print.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';

import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SlimLoadingBarModule } from '@cime/ngx-slim-loading-bar';
import { FormsModule } from '../../node_modules/@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { Ng5SliderModule } from 'ng5-slider';
import { NgxCurrencyModule } from "ngx-currency";
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { ToastrModule } from 'ngx-toastr';

export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ".",
  precision: 0,
  prefix: "$ ",
  suffix: "",
  thousands: ",",
  nullable: true
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    LoginComponent,
    OptimizerComponent,
    PrintComponent,
    ProgressSpinnerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    Ng5SliderModule,
    SlimLoadingBarModule,
    BrowserAnimationsModule,
    NgxPageScrollCoreModule,
    NgxPageScrollModule,
    ChartsModule,
    ToastrModule.forRoot(),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    MatProgressSpinnerModule,
    MatDialogModule,
  ],
  providers: [OptimizerServiceService],
  bootstrap: [AppComponent],
  entryComponents: [ProgressSpinnerComponent]
})
export class AppModule { }
